<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-separations-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupSeparationsContainerView: () => import('@/components/hris/setup/separations/ContainerView'),
    },
  }
</script>
